import { useTranslation } from "@/lib/i18n/client";
import { useLocation } from "@tanstack/react-router";
import { useLng } from "@/hooks/use-lng";

export default function Spinner() {
  const lng = useLng();
  const { t } = useTranslation(lng, "translation");
  const path = useLocation({ select: (l) => l.pathname });
  const isUpdatePage = path.includes("update");
  return (
    <div className="absolute top-0 z-50 -ml-4 flex h-full w-screen items-center justify-center backdrop-blur-xs transition-all duration-100 md:-ml-5 md:h-full md:w-full">
      <div className={`${!isUpdatePage && "mb-12"} flex flex-col items-center justify-center`}>
        <svg
          className="text-primary h-8 w-8 animate-spin"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <span className="mt-2 font-semibold">{t("loading-spinner-wait")}</span>
      </div>
    </div>
  );
}
